export const PaymentGatewayMapper = (gateway) => {
    if (gateway === "Cashfree") return "cashfree"
    else if (gateway === "Easebuzz") return "easebuzz_logo"
    else if (gateway === "Wired Transfer") return "wire_transfer"
    else if (gateway === "Instant Pay") return "InstantPay"
    else return "easebuzz_logo"
}

